import { render, staticRenderFns } from "./SsBalancePage.vue?vue&type=template&id=fa59a2e6"
import script from "./SsBalancePage.vue?vue&type=script&lang=ts"
export * from "./SsBalancePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports